import React from 'react'
import TitleSearch from '../../Components/TitleSearch/TitleSearch'
import FilterList from "../../Components/CollectionsFilterPanel/CollectionsFilterPanel";

type Props = {}

const PublicCollectionsPage = (props: Props) => {
  return (
    <>
    <TitleSearch />
    <FilterList />
    </>
  )
}

export default PublicCollectionsPage